import {
  GET_STATUSSAMPLE_FAIL,
  GET_STATUSSAMPLE_SUCCESS,
  GET_STATUSSAMPLES_FAIL,
  GET_STATUSSAMPLES_SUCCESS,
  ADD_STATUSSAMPLE_SUCCESS,
  ADD_STATUSSAMPLE_FAIL,
  UPDATE_STATUSSAMPLE_SUCCESS,
  UPDATE_STATUSSAMPLE_FAIL,
  DELETE_STATUSSAMPLE_SUCCESS,
  DELETE_STATUSSAMPLE_FAIL,  
  SET_STATE_STATUSSAMPLE
} from "./actionTypes";

const INIT_STATE = {
  statusSamples: [],
  statusSample: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const statusSamples = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_STATUSSAMPLES_SUCCESS:
      return {
        ...state,
        statusSamples: action.payload.statusSamples,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_STATUSSAMPLE:
      return { ...state, loading: action.payload }

    case GET_STATUSSAMPLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_STATUSSAMPLE_SUCCESS:
      return {
        ...state,
        statusSamples: [...state.statusSamples, action.payload],
      };

    case ADD_STATUSSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_STATUSSAMPLE_SUCCESS:
      return {
        ...state,
        statusSamples: state.statusSamples.map(statusSample =>
          statusSample.id.toString() === action.payload.id.toString()
            ? { ...action.payload, statusSample }
            : statusSample
        ),
      };

    case UPDATE_STATUSSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_STATUSSAMPLE_SUCCESS:
      return {
        ...state,
        statusSamples: state.statusSamples.filter(
          statusSample => statusSample.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_STATUSSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_STATUSSAMPLE_SUCCESS:
      return {
        ...state,
        statusSample: action.payload,
      };

    case GET_STATUSSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default statusSamples;
